import { jsx as o } from "react/jsx-runtime";
import { useState as a } from "react";
import { renderOption as c } from "../utils/render-list-option.mjs";
import { ListLoader as h } from "./list-loader.mjs";
import { ListOptionsWrapper as u } from "./list-options-wrapper.mjs";
import { getPanelHeight as g } from "../utils/get-panel-height.mjs";
function H({
  optionsClassName: r,
  data: t,
  loaderWrapperClassName: i,
  loaderClassName: e,
  asOptions: s,
  asOption: n,
  ...p
}) {
  const [m, f] = a(null), l = g(m, t);
  return /* @__PURE__ */ o(
    u,
    {
      as: s,
      ref: f,
      optionsClassName: r,
      style: { height: l },
      children: ({ option: L }) => t ? c({ ...p, as: n, item: L }) : /* @__PURE__ */ o(
        h,
        {
          loaderWrapperClassName: i,
          loaderClassName: e
        }
      )
    }
  );
}
export {
  H as ListOptions
};
